import React from 'react';
import cud from '../cud';
import {v4} from 'uuid';

const wdl = {
    set: function(key, value) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({[key]: value});
    }
};

if (cud) {
    wdl.set('algoliaUserToken', v4());
}

export const WdlContext = React.createContext({});

export const WdlProvider = React.memo(({ children }) => {
    const [state] = React.useState(() => wdl);
    return (
        <WdlContext.Provider value={state}>
            {children}
        </WdlContext.Provider>
    );
});

export const useWdl = () => React.useContext(WdlContext);